/// <amd-module name="Search/WorkItem/Flux/Sources/PreferenceSpy" />

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub";
import { ActionsHub } from "Search/WorkItem/Flux/ActionsHub";
import { ISearchLocalSettingsService } from "Search/Shared/Base/LocalSettingsService";
import { IVssPageContext } from "VSS/Platform/Context";
import { PreferenceConstants } from "Search/WorkItem/Constants";

export class PreferenceSpy {
    private readonly settingsService: ISearchLocalSettingsService;

    constructor(private readonly pageContext: IVssPageContext, private readonly actionsHub: ActionsHub) {
        this.settingsService = this.pageContext.getService<ISearchLocalSettingsService>("ISearchLocalSettingsService");
        this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.splitterFixedSizeChanged.addListener(this.persistSplitterFixedSize);
        this.actionsHub.previewOrientationChanged.addListener(this.persistPreviewOrientation);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.splitterFixedSizeChanged.removeListener(this.persistSplitterFixedSize);
        this.actionsHub.previewOrientationChanged.removeListener(this.persistPreviewOrientation);
    }

    private persistSplitterFixedSize = (newFixedSize: number): void => {
        setTimeout(() => {
            this.settingsService.setValue(PreferenceConstants.SplitterFixedSizeKey, newFixedSize);
        }, 0)
    }

    private persistPreviewOrientation = ({ previewOrientation }: BaseActionsHub.IPreviewOrientationChangedPayload): void => {
        setTimeout(() => {
            this.settingsService.setValue(PreferenceConstants.PreviewOrientationKey, previewOrientation.key);
        }, 0);
    }
}
